import { batch, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { addActiveAccountProfileToSummary } from '../../../../../actions/account';
import useSelectUserProfile from '../../../hooks/useSelectUserProfile';
import { DataLock } from '../../../../../core/util/dataLock';
import { profileFormSubmission } from '../../../../../actions/profile';
import { convertSnakeToCamelCase } from '../../../../../core/util/object';
import { useSolvSelector } from '~/reducers';

const dataLock = new DataLock('', { timeout: null });

const useEffectSetActiveAccountProfile = (userProfileId: any) => {
  const dispatch = useDispatch();
  const userProfile = useSelectUserProfile(userProfileId);
  const accountPhone = useSolvSelector(
    (state) => state.account.summary && state.account.summary.phone
  );
  useEffect(() => {
    if (dataLock.isSameOrSet(userProfileId)) return;

    const withPhoneProfile = { ...userProfile, phone: userProfile.phone_primary || accountPhone };

    const snakedProfile = convertSnakeToCamelCase(withPhoneProfile);
    batch(() => {
      dispatch(addActiveAccountProfileToSummary(withPhoneProfile));
      dispatch(profileFormSubmission({ ...snakedProfile, withPhoneProfile }));
    });
  }, [dispatch, userProfile, userProfileId, accountPhone]);
};

export default useEffectSetActiveAccountProfile;
